import { Col } from 'antd';

import { useAppSelector } from '@store/store.tsx';
import { selectSiteSettings } from '@store/slices/settingsSlice.tsx';
import {
  buildCatalogueSocialLinks,
  CatalogueSocialIcon,
} from '@components/layout/catalogueSocial.tsx';

const CatalogueSocialBar = () => {
  const settings = useAppSelector(selectSiteSettings);
  const links = buildCatalogueSocialLinks(settings);

  if (links.length === 0) {
    return null;
  }

  return (
    <Col xs={24} className="catalogue-social-row">
      <section
        className="catalogue-social-bar"
        aria-labelledby="catalogue-social-title"
      >
        <h2 id="catalogue-social-title" className="catalogue-social-bar__title">
          Seguinos en nuestras redes
        </h2>
        <div className="catalogue-social-bar__links">
          {links.map((link) => (
            <a
              key={link.key}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="catalogue-social-bar__link"
            >
              <span
                className={`catalogue-social-bar__icon catalogue-social-bar__icon--${link.key}`}
              >
                <CatalogueSocialIcon link={link} size={24} />
              </span>
              <span
                className={`catalogue-social-bar__text catalogue-social-bar__text--${link.key}`}
              >
                <strong>{link.label}</strong>
                <small>{link.handle}</small>
              </span>
            </a>
          ))}
        </div>
      </section>
    </Col>
  );
};

export default CatalogueSocialBar;
